module.exports = __webpack_public_path__ + "static/media/xuanqi.af254a93.jpg";